import type {TFunction} from 'i18next';

/** Marks a field the locale has no wording for — no label can ever equal it. */
const NO_LABEL = ' ';

/**
 * The server drops whatever failed validation, and the keys it names are raw event/ticket
 * columns — telling the producer "timeZone was not saved" is worse than not naming it. Only
 * fields the locale has real wording for are named; everything else collapses into one
 * generic mention, so a new server-side field can never leak its key into the chat.
 */
export function buildDroppedFieldsNotice(fields: string[], t: TFunction): string {
    const labels: string[] = [];
    let hasUnnamedField = false;

    fields.forEach(field => {
        const label = t(`droppedField.${field}`, {defaultValue: NO_LABEL});
        if(label === NO_LABEL) {
            hasUnnamedField = true;
            return;
        }
        if(!labels.includes(label)) {
            labels.push(label);
        }
    });

    if(hasUnnamedField) {
        labels.push(t('droppedFieldOther'));
    }

    return t('proposalDroppedFields', {list: labels.join(', ')});
}
